var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCy = function SvgIconCy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M18.783 10.435h-1.565a5.217 5.217 0 1 1-10.435 0H5.218a6.785 6.785 0 0 0 4.93 6.526 1.74 1.74 0 0 0 .182 1.895l1.705-1.367 1.706 1.367c.45-.561.494-1.317.172-1.913a6.785 6.785 0 0 0 4.87-6.508"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M7.826 9.913s0 2.609 2.609 2.609l.522.521H12s.522-1.565 1.565-1.565c0 0 0-1.043 1.044-1.043h1.565s-.522-2.087 2.087-3.653l-1.044-.521s-3.652 2.608-6.26 2.087V9.39H9.913l-.522-.522z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconCy;